export default {
  summary: {
    delivery: 'Livrare: Card cadou ca PDF prin e-mail',
  },
};
